<template>
    <v-card>
        <v-card-text>

            <v-layout>
                <v-flex xs12>
                    <v-alert type="error" v-model="error_alert">{{ err_msg }}</v-alert>
                </v-flex>
            </v-layout>

            <v-layout row wrap justify-start v-if="current_status == 'draft' || current_status == 'expired'">

                <v-spacer></v-spacer>

                <v-flex xs12 sm5 md3 mr-4>
                    <v-btn block color="green" v-if="current_status == 'draft'" :disabled="disableSubmit" @click="submitQuote()" dark>
                        <v-icon small left>fa-share-square</v-icon>{{ submit_button_verbage }}
                    </v-btn>
                    <!-- Comment out the ReQuote Button for Production Testing! -->
                        <v-btn block color="green" v-if="false && current_status == 'expired'" :disabled="disableRequote" @click="requoteQuote()" dark>
                            <v-icon small left>fa-share-square</v-icon>{{ requote_button_verbage }}
                        </v-btn>
                    <!-- -->
                </v-flex>

                <v-flex xs12 sm5 md3 mr-4>
                    <v-btn xs12 sm6 md4 :block="$vuetify.breakpoint.xsOnly" color="primary" :disabled="loading" @click="addItem()">
                        <v-icon small left>fa-plus</v-icon>New Item
                    </v-btn>
                </v-flex>

                <v-flex xs12 sm6 md4>
                    <v-text-field v-model="search" append-icon="fa-search" label="Search" single-line hide-details></v-text-field>
                </v-flex>
            </v-layout>

            <h3 class="grey--text">{{ title }}</h3>

            <v-data-table class="quote-item-table" :loading="loading" :headers="headers" :items="items" :search="search" :pagination.sync="pagination" hide-actions>

                <template slot="items" slot-scope="props">

                    <tr @click="props.expanded = !props.expanded">
                        <td class="text-xs-center hide-column ipad">
                            <v-btn fab small>
                                <v-icon v-if="!props.expanded">fa-caret-right</v-icon>
                                <v-icon v-if="props.expanded">fa-caret-down</v-icon>
                            </v-btn>
                        </td>
                        <td class="text-xs-center">
                            {{ props.item.item_num }}
                        </td>
                        <td class="text-xs-left">
                            {{ props.item.product.label }}
                        </td>
                        <td class="text-xs-center">
                            {{ props.item.quantity }}
                        </td>
                        <td class="text-xs-center hide-column">
                            <span v-if="(props.item.product.tutco_id != 'ROUNDF') && (props.item.product.tutco_id != 'EPH2')">
                                {{ props.item.width }}in. x {{ props.item.height }}in.
                            </span>
                            <span v-else>
                                {{ props.item.diameter }}in.
                            </span>
                        </td>
                        <td class="text-xs-center hide-column">
                            {{ props.item.kw }}kW
                        </td>
                        <td class="text-xs-center hide-column ipad">
                            {{ props.item.tagging }}
                        </td>
                        <td class="text-xs-center">
                            ${{ Number(props.item.list_price).toFixed(2) }}
                        </td>
                        <td class="text-xs-center" v-if="current_status == 'draft'">
                            <v-layout row>
                                <v-btn flex v-if="$vuetify.breakpoint.xsOnly" :disabled="loading || ((props.item.id < cutover_id) && (props.item.product_id == 6))" small fab color="primary" @click="editItem(props.item.id)">
                                    <v-icon>fa-edit</v-icon>
                                </v-btn>
                                <v-btn flex v-else :disabled="loading || ((props.item.id < cutover_id) && (props.item.product_id == 6))" color="primary" @click="editItem(props.item.id)">
                                    <v-icon small left>fa-edit</v-icon>Edit
                                </v-btn>
                                <v-btn flex :disabled="loading" fab small @click="deleteItem(props.item.id)">
                                    <v-icon>fa-times</v-icon>
                                </v-btn>
                            </v-layout>
                        </td>
                    </tr>
                </template>

                <template slot="expand" slot-scope="props">
                    <v-card>
                        <v-card-text>
                            <v-layout row wrap v-if="set_options(props.item).length > 0">
                                <v-flex xs12 sm6 md4 v-for="(option, key) in set_options(props.item)" :key="key">
                                    {{ option.label }} ({{ option.value }})
                                </v-flex>
                            </v-layout>
                            <div v-else>No options set for this item.</div>
                        </v-card-text>
                    </v-card>
                </template>
            </v-data-table>

        </v-card-text>

        <div class="text-xs-center pt-2" v-if="pages > 1">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </div>

    </v-card>
</template>

<script>

const request = require('superagent');
import Options from '../tutco/options';

export default {
    props: ['items', 'title', 'quoteId', 'status', 'revNumber'],

    data: function() {
        return {
            headers: [{
                    'text': '',
                    'value': 'id',
                    'align': 'center',
                    'width': '5px',
                    'class': 'hide-column ipad',
                    'sortable': false
                },
                {
                    'text': 'Line #',
                    'value': 'item_num',
                    'align': 'center',
                    'width': '1px'
                },
                {
                    'text': 'Product',
                    'value': 'product.label',
                    'align': 'left',
                },
                {
                    'text': 'Quantity',
                    'value': 'quote_qty',
                    'align': 'center',
                    'width': '5px'
                },
                {
                    'text': 'Size',
                    'value': 'size',
                    'align': 'center',
                    'width': '60px',
                    'class': 'hide-column'
                },
                {
                    'text': 'kW',
                    'value': 'kw',
                    'align': 'center',
                    'width': '10px',
                    'class': 'hide-column'
                },
                {
                    'text': 'Tagging',
                    'value': 'tagging',
                    'align': 'center',
                    'width': '10px',
                    'class': 'hide-column ipad'
                },
                {
                    'text': 'Unit Price',
                    'value': 'ext_price',
                    'align': 'center',
                },
                {
                    'text': '',
                    'sortable': false
                }
            ],
            //[DAMAGE] WE HAVE TWO 'search' props!!!
            search: '',
            pagination: { rowsPerPage: 100, sortBy: 'id', descending: false },
            //[DAMAGE] WE HAVE TWO 'search' props!!!
            search: '',
            loading: false,
            error_alert: false,
            err_msg: '',
            current_status: null,
            cutover_id : 79994 //79326 [WARNING] This will need to be set and rebuilt before Cut-Over for 12" Duct Heater
        }
    },
    mounted() {
        this.current_status = this.status;
    },
    computed: {
        pages() {
            if (this.pagination.rowsPerPage == null ||
                this.pagination.totalItems == null
            ) return 0

            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        },
        // Button Text for Submit
        submit_button_verbage() {
            if (this.revNumber > 0) {
                //return "Save Changes";
            }
            return "Submit Quote";
        },
        // Button Text for ReQuote
        requote_button_verbage() {
            if (this.revNumber > 0) {
                //return "Save Changes";
            }
            return "Re-Quote";
        },
        // Disable the Quote and ReQuote Buttons if we're loading or there are no products on the quote
        disableSubmit: function() {
            if (this.loading) {
                return true;
            }
            if (typeof this.items == 'undefined' || this.items.length == 0) {
                return true;
            }
            return false;
        },
        disableRequote: function() {
            if (this.loading) {
                return true;
            }

            if (typeof this.items == 'undefined' || this.items.length == 0) {
                return true;
            }

            //[DAMAGE] Make sure we don't have any Round Duct Heaters for Now - Not Yet Supported...
            if( this.items.some( function(item) { return item.product_id == 6; } ))
            {
                return true;
            }

            // We're good for ReQuote...
            return false;
        }
    },
    methods: {





        submitQuote: function()
        {
            var g = this;
            this.loading = true;
            this.error_alert = false;
            request
                .post(window.base_url + "/quote/" + this.quoteId + "/submit")
                .send({
                    _token: window.csrf,
                    _method: 'POST'
                })
                .then(function(res, err) {
                    g.loading = false;
                    if (res.body.success) {
                        var total = 0;
                        var ecommerce_items = [];
                        for (var i = 0; i < g.items.length; i++) {
                            total += Number(g.items[i].list_price)*g.items[i].quantity
                            ecommerce_items.push({
                                'item_name': g.items[i].product.tutco_id,
                                'price': Number(g.items[i].list_price),
                                'quantity': g.items[i].quantity
                            })
                        }
                        window.dataLayer.push({
                            event: 'add_to_cart',
                            'ecommerce': {
                                'value': total,
                                'currency': "USD",
                                'items': ecommerce_items
                            }
                        });

                        g.ga('submit-quote', g.quoteId, function() {
                            g.current_status = res.body.quote.status;
                            document.location = window.base_url + "/quote/" + g.quoteId;
                        })

                    } else {
                        if (g.current_status != res.body.quote.status) {
                            g.ga('submit-quote-error', g.quoteId, function() {
                                g.current_status = res.body.quote.status;
                                g.showError(res.body.msg + " This page will now reload.");
                                setTimeout(function() { location.reload(); }, 2000);
                            })
                        }
                    }
                    console.log(res.body);
                }).catch(function(err) {
                    console.log(err);
                    g.loading = false;
                    g.showError(err.status + " - There was a problem connecting to the webserver. Your quote was not submitted.");
                });
        },

        requoteQuote: function()
        {

            var g = this;
            this.loading = true;
            this.error_alert = false;
            request
                .post(window.base_url + "/quote/" + this.quoteId + "/requote")
                .send({
                    _token: window.csrf,
                    _method: 'POST'
                })
                .then(function(res, err) {
                    g.loading = false;
                    if (res.body.success)
                    {
                        //error response from server (tutco web server error maybe)
                        g.ga('requote-quote', g.quoteId, function() {
                            g.current_status = res.body.quote.status;

                            // Get the new Quote Id returned by our call
                            var newQuoteId = res.body.quote.id;
                            console.log(newQuoteId);
                            console.log(res.body.msg);
                            document.location = window.base_url + "/quote/" + newQuoteId;
                        })
                    }
                    else
                    {
                        if (g.current_status != res.body.quote.status) {
                            g.ga('requote-quote-error', g.quoteId, function() {
                                g.current_status = res.body.quote.status;
                                g.showError(res.body.msg + " This page will now reload.");
                                setTimeout(function() { location.reload(); }, 2000);
                            })
                        }
                    }
                    console.log(res.body);
                }).catch(function(err) {
                    console.log(err);
                    g.loading = false;
                    g.showError(err.status + " - There was a problem connecting to the webserver. Quote not submitted for ReQuoting.");
                });
        },

        ga: function(action, label, callback) {
            if (typeof callback != 'function') {
                callback = function() { console.log('callback') };
            }
            if (typeof gtag != 'undefined') {
                window.dataLayer.push({
                    event: 'ga_event',
                    event_category: 'tutco-portal',
                    event_label: label,
                    event_action: action,
                    eventCallback: callback
                });
            } else {
                callback();
            }
        },

        editItem: function(id)
        {
            document.location = window.base_url + "/quoteitem/" + id + "/edit";
        },
        deleteItem: function(id) {

            var g = this;
            this.loading = true;
            this.error_alert = false;
            request
                .post(window.base_url + "/quoteitem/" + id)
                .send({
                    _token: window.csrf,
                    _method: 'DELETE'
                })
                .then(function(res) {
                    if (res.body.deleted) {
                        //re-number the existing items based on what is returned from the server.
                        var delete_index = null;
                        for (var i = 0; i < g.items.length; i++) {
                            if (typeof res.body.quoteitems[g.items[i].id] == 'undefined') {
                                //delete it from the array.
                                delete_index = i
                            } else {
                                g.items[i].item_num = res.body.quoteitems[g.items[i].id];
                            }
                        }
                        g.items.splice(delete_index, 1);
                        g.pagination.totalItems = g.items.length;
                        if (g.pagination.page > g.pages) {
                            g.pagination.page = g.pages;
                        }
                    } else {
                        g.showError(res.body.msg + ". Your item was not deleted.");
                    }
                    g.loading = false;
                }).catch(function(err) {
                    g.loading = false;
                    g.showError(err.status + " - There was a problem connecting to the webserver. Your quote was not submitted.");
                });
        },
        addItem: function() {
            document.location = window.base_url + "/quoteitem/create/" + this.quoteId;
        },
        showError: function(msg) {
            this.error_alert = true;
            this.err_msg = msg;
            var g = this;
            //setTimeout(function(){g.error_alert = false}, 5000);
        },
        set_options: function(item) {
            var opt = [];
            for (var i = 0; i < item.accessories.length; i++) {
                opt.push({
                    label: item.accessories[i].label,
                    value: item.accessories[i].code
                })
            }
            return opt;
        }
    },
    watch: {

    }
}

</script>
<style>
.quote-item-table table.v-table tbody td:not(:first-child) {
    padding-left: 5px;
    padding-right: 5px;
}

@media screen and (max-width: 1024px) {
    .hide-column.ipad {
        display: none;
    }
}

</style>
